(function () {
  Flint.file("views/pages/contactPage.js", function (require) {
    Flint.staticStyles("ContactPage", {
      "$page": "#_flintapp page.ContactPage, #_flintapp .ContactPage.page, #_flintapp .ViewContactPage.page, #_flintapp .ContactPage > .page",
      "$header": "#_flintapp header.ContactPage, #_flintapp .ContactPage.header, #_flintapp .ViewContactPage.header, #_flintapp .ContactPage > .header",
      "$icon": "#_flintapp icon.ContactPage, #_flintapp .ContactPage.icon, #_flintapp .ViewContactPage.icon, #_flintapp .ContactPage > .icon",
      "$addr": "#_flintapp addr.ContactPage, #_flintapp .ContactPage.addr, #_flintapp .ViewContactPage.addr, #_flintapp .ContactPage > .addr",
      "$addressSec": "#_flintapp addressSec.ContactPage, #_flintapp .ContactPage.addressSec, #_flintapp .ViewContactPage.addressSec, #_flintapp .ContactPage > .addressSec",
      "$emailSec": "#_flintapp emailSec.ContactPage, #_flintapp .ContactPage.emailSec, #_flintapp .ViewContactPage.emailSec, #_flintapp .ContactPage > .emailSec",
      "$emailIcon": "#_flintapp emailIcon.ContactPage, #_flintapp .ContactPage.emailIcon, #_flintapp .ViewContactPage.emailIcon, #_flintapp .ContactPage > .emailIcon",
      "$emailInfo": "#_flintapp emailInfo.ContactPage, #_flintapp .ContactPage.emailInfo, #_flintapp .ViewContactPage.emailInfo, #_flintapp .ContactPage > .emailInfo",
      "$phoneSec": "#_flintapp phoneSec.ContactPage, #_flintapp .ContactPage.phoneSec, #_flintapp .ViewContactPage.phoneSec, #_flintapp .ContactPage > .phoneSec",
      "$phoneIcon": "#_flintapp phoneIcon.ContactPage, #_flintapp .ContactPage.phoneIcon, #_flintapp .ViewContactPage.phoneIcon, #_flintapp .ContactPage > .phoneIcon",
      "$phoneInfo": "#_flintapp phoneInfo.ContactPage, #_flintapp .ContactPage.phoneInfo, #_flintapp .ViewContactPage.phoneInfo, #_flintapp .ContactPage > .phoneInfo"
    }, {
      "$page": {
        padding: [20, 20, 60]
      },
      "$header": {
        fontSize: 36
      },
      "$icon": {
        width: 32,
        height: 32,
        marginRight: 16
      },
      "$addr": {
        fontFamily: 'helvetica neue'
      },
      "$addressSec": {
        marginTop: 12,
        marginBottom: 20,
        flexDirection: 'row'
      },
      "$emailSec": {
        flexDirection: 'row',
        marginBottom: 20
      },
      "$emailIcon": {
        marginLeft: 5,
        width: 24,
        marginRight: 17
      },
      "$emailInfo": {
        marginTop: 2
      },
      "$phoneSec": {
        flexDirection: 'row'
      },
      "$phoneIcon": {
        width: 14,
        height: 29,
        marginLeft: 11,
        opacity: 0.7
      },
      "$phoneInfo": {
        marginTop: 5,
        marginLeft: 6
      }
    });
    Flint.view("ContactPage", function (view, on, $) {
      on.mount(function () {
        M.mixpanel.track("PageView", { page: 'contact' });
      });view.render(function () {
        return view.el(["NavBar", 1], null);
      });view.render(function () {
        return view.el(
          ["page", 1],
          null,
          view.el(
            ["header", 1],
            null,
            "Contact"
          ),
          view.el(
            ["addressSec", 1],
            null,
            view.el(["img", 1], { className: "icon", src: "/images/location.png" }),
            view.el(
              ["addressInfo", 1],
              null,
              view.el(
                ["pr", 1],
                null,
                "Positive Relating"
              ),
              view.el(
                ["addr", 1],
                null,
                view.el(
                  ["street", 1],
                  null,
                  "701 Westbourne Dr"
                ),
                view.el(
                  ["city", 1],
                  null,
                  "West Hollywood, CA 90069"
                )
              )
            )
          ),
          view.el(
            ["emailSec", 1],
            null,
            view.el(["img", 2], { className: ['icon', 'emailIcon'], src: "/images/email.png" }),
            view.el(
              ["emailInfo", 1],
              null,
              view.el(
                ["a", 1],
                { href: "mailto:info@positiverelating.tv" },
                "info@positiverelating.tv"
              )
            )
          ),
          view.el(
            ["phoneSec", 1],
            null,
            view.el(["img", 3], { className: ['icon', 'phoneIcon'], src: "/images/phone.png" }),
            view.el(
              ["phoneInfo", 1],
              null,
              "1 (888) 634-6988"
            )
          )
        );
      });view.render(function () {
        return view.el(["Footer", 1], null);
      });
    });
  })
})();
//# sourceMappingURL=contactPage.js.map
